import { DetailCard } from '#components/atoms/cards/detail-card/DetailCard.tsx';
import { Pill } from '#components/atoms/pill/Pill.tsx';
import { FREE_PLAN_HOST_LIMIT } from '../constants.ts';
import { HostUsageMeter } from '../host-usage-meter/HostUsageMeter.tsx';
import { FeatureList } from './FeatureList.tsx';
import styles from './FreePlanCard.module.css';

const FEATURES = [
  `Up to ${FREE_PLAN_HOST_LIMIT} hosts (including lighthouses and relays)`,
  '2 routes for external hosts',
  'Support for Linux, Windows, macOS, iOS, and Android',
  'Single sign-on (SSO)',
];

type Props = {
  /** Current enrolled host count (includes lighthouses and relays) */
  currentHostCount: number;
};

export function FreePlanCard({ currentHostCount }: Props) {
  return (
    <DetailCard className={styles.FreePlanCard}>
      <div className="flex gap-8 align-center justify-between">
        <h2 className="h4 mb-0">Free</h2>
        <Pill>Current plan</Pill>
      </div>
      <div className="flex gap-8 align-center">
        <span className="h1 mb-0">$0</span>
        <span className="h6 mb-0 nowrap">/mo</span>
      </div>
      <HostUsageMeter currentHostCount={currentHostCount} />
      <FeatureList features={FEATURES} />
    </DetailCard>
  );
}
